import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { Link as RRDLink } from "react-router-dom";
import { Link as MuiLink } from "@material-ui/core";

export const WrappedLinkRouter = forwardRef((props, ref) => (
  <RRDLink innerRef={undefined} {...props} /> 
  
));
WrappedLinkRouter.displayName = "WrappedLinkRouter";

const WrappedLink = ({
  children,
  to = "/",
  external = false,
  underline = "none",
  url = null,
  ...props
}) => (
  <MuiLink
    underline={underline}
    {...props}
    component={url != null ? undefined : WrappedLinkRouter}
    rel={external ? "noopener noreferrer" : props.rel}
    target={external ? "_blank" : "_self"}
    to={url != null ? undefined : to}
    href={url != null ? url : undefined}
  >
    {children}
  </MuiLink>
);

WrappedLink.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]),
  url: PropTypes.string,
  className: PropTypes.string,
  external: PropTypes.bool
};

export default WrappedLink;
